<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <!-- 销户 -->
    <a-spin :spinning="confirmLoading">

      <j-form-container>
        <a-form-model ref="form" :model="tearDownModel" :rules="tearDownModelValidatorRules" slot="detail" :colon="false">
          <!-- 用户基本信息 - 包含个人 企业 -->
          <a-row :gutter="24">
            <!-- 个人用户信息 -->
            <a-col :span="24" v-if="tearDownModel.userIdType == 1">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('用户基本信息') }}</a-divider>
              
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('用户编号')">{{ tearDownModel.userId }}</a-descriptions-item>
                <a-descriptions-item :label="$t('用户姓名')">{{ tearDownModel.userName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('用户电话')">{{ tearDownModel.userPhone }}</a-descriptions-item>
                <!-- <a-descriptions-item label="用户地址">{{ tearDownModel.setAddr }}</a-descriptions-item> -->
              </a-descriptions>
              
              <a-divider class="aDividerBlue" orientation="left">{{ $t('其他信息') }}</a-divider>
              
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('申请原因')">{{ tearDownModel.applyDescription }}</a-descriptions-item>
              </a-descriptions>
              
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('电子签名')"></a-descriptions-item>
              </a-descriptions>
              <j-image-upload 
                class="avatar-uploader" 
                :text="$t('上传')" 
                :isMultiple="true" 
                v-model="tearDownModel.applySignature" 
                :disabled="true"
              />
              
              <!-- <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false">
                <img style="width: 180px; height: 80px;" :src="tearDownModel.applySignature"/>
                <div class="mask-sig" :class="{'mask-show': isShow}">
                  <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                  <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                </div>
              </div> -->
              
              <a-row :gutter="16" style="margin-top: 16px;">
                <a-col :span="16">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('身份证正反面')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="fileList" 
                    :disabled="true"
                  />
                </a-col>
                
                <a-col :span="8">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('房产证')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="tearDownModel.userTitleDeed" 
                    :disabled="true"
                  />
                </a-col>
              </a-row>
              
              <template v-if="!tearDownModel.selfFlag">
                <a-row :gutter="16" style="margin-top: 16px;">
                  <a-col :span="16">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('被委托人身份证（正反面）')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                      class="avatar-uploader" 
                      :text="$t('上传')" 
                      :isMultiple="true" 
                      v-model="reportUserFileList" 
                      :disabled="true"
                    />
                  </a-col>
                  
                  <a-col :span="8">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('委托书')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                      class="avatar-uploader" 
                      :text="$t('上传')" 
                      :isMultiple="true" 
                      v-model="tearDownModel.reportUserInformation" 
                      :disabled="true"
                    />
                  </a-col>
                </a-row>
              </template>
            </a-col>

            <!-- 企业用户信息 -->
            <a-col :span="24" v-if="tearDownModel.userIdType == 0">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('企业基本信息') }}</a-divider>
              
              <a-descriptions :col="3" >
                <a-descriptions-item :label="$t('企业编号')">{{ tearDownModel.userId }}</a-descriptions-item>
                <a-descriptions-item :label="$t('企业名称')">{{ tearDownModel.userName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('企业电话')">{{ tearDownModel.userPhone }}</a-descriptions-item>
                <a-descriptions-item :label="$t('企业地址')">{{ tearDownModel.setAddr }}</a-descriptions-item>
                <a-descriptions-item v-if="tearDownModel.userName" :label="$t('法人姓名')">{{ tearDownModel.userName }}</a-descriptions-item>
                <a-descriptions-item v-if="tearDownModel.userPhone" :label="$t('法人电话')">{{ tearDownModel.userPhone }}</a-descriptions-item>
                <a-descriptions-item v-if="tearDownModel.userIdNumber" :label="$t('法人身份证号')">{{ tearDownModel.userIdNumber }}</a-descriptions-item>
              </a-descriptions>
              
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('申请原因')">{{ tearDownModel.applyDescription }}</a-descriptions-item>
              </a-descriptions>
              
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('电子签名')"></a-descriptions-item>
              </a-descriptions>
              <j-image-upload 
                class="avatar-uploader" 
                :text="$t('上传')" 
                :isMultiple="true" 
                v-model="tearDownModel.applySignature" 
                :disabled="true"
              />
              
              <!-- <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false">
                <img style="width: 180px; height: 80px;" :src="tearDownModel.applySignature"/>
                <div class="mask-sig" :class="{'mask-show': isShow}">
                  <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                  <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                </div>
              </div> -->
              
              <a-row :gutter="16" style="margin-top: 16px;">
                <a-col :span="16">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('法人身份证正反面')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="fileList" 
                    :disabled="true"
                  />
                </a-col>
                
                <a-col :span="8">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('公司营业执照')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="tearDownModel.userTitleDeed" 
                    :disabled="true"
                  />
                </a-col>
              </a-row>
              
              <template v-if="!tearDownModel.selfFlag">
                <a-row :gutter="16" style="margin-top: 16px;">
                  <a-col :span="16">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('被委托人身份证（正反面）')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                      class="avatar-uploader" 
                      :text="$t('上传')" 
                      :isMultiple="true" 
                      v-model="reportUserFileList" 
                      :disabled="true"
                    />
                  </a-col>
                  
                  <a-col :span="8">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('委托书')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                      class="avatar-uploader" 
                      :text="$t('上传')" 
                      :isMultiple="true" 
                      v-model="tearDownModel.reportUserInformation" 
                      :disabled="true"
                    />
                  </a-col>
                </a-row>
              </template>
            </a-col>

            <a-col :span="24">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('用水性质变更') }}</a-divider>
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('价格信息')">{{priceList[(tearDownModel.valueJson||{}).newPriceId]}}</a-descriptions-item>
                <a-descriptions-item :label="$t('变更方式')">{{(tearDownModel.valueJson||{}).changeWay==1?$t('立即结算'):(tearDownModel.valueJson||{}).changeWay==2?$t('扣完再启用新价格'):''}}</a-descriptions-item>
                <a-descriptions-item :label="$t('启用日期')">{{(tearDownModel.valueJson||{}).startDate}}</a-descriptions-item>
              </a-descriptions>
            </a-col>

          </a-row>

          <!-- 审批信息 -->
          <a-row :gutter="24" v-if="!notInput">
            <a-col :span="24">
              <a-form-model-item :label="$t('审批意见')" prop="isAgree">
                <a-radio-group v-model="tearDownModel.isAgree">
                  <a-radio :value="1">{{ $t('通过') }}</a-radio>
                  <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('审批描述')" prop="approvalDescription">
                <a-textarea v-model="tearDownModel.approvalDescription" :placeholder="$t('请输入审批描述')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>

      </j-form-container>

    </a-spin>

    <j-modal :title="$t('预览')" :width="448" :visible="visibleSig" @cancel="handleSigCancel" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
      <div style="width: 400px;height: 400px;">
        <img :src="tearDownModel.applySignature" alt="" style="width: 100%;height: 100%;" />
      </div>
    </j-modal>

  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    // mixins: [JeecgListMixin],
    name: 'TransferUser',
    components: {
      JImageUpload,
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        optionType:"", // 操作类型 报停 复接
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        infoId: "", // 传入数据主键
        tearDownModel: { // 报停对象
          userType: undefined, // 用户类型 户主1 非户主0
          valueJson: {}
        },
        installModel: { // 复接对象
          userType: undefined // 用户类型 户主1 非户主0
        },
        url: {
          updateState: "/jeecg-charge/meter/wechatUserApply/updateState",
          priceList: "/jeecg-charge/meter/meterPriceinfo/list",
          userTypeList: "/jeecg-charge/meter/meterUserType/list",
          queryById: "/jeecg-charge/meter/wechatUserApply/queryById",
        },
        priceList: {},
        userTypeList: {},
        isShow: false,
        fileList:'', // 本人身份证
        reportUserFileList:'', // 被委托人身份证
        visibleSig:false,
        notInput:false,
      }
    },
    computed: {
      tearDownModelValidatorRules() {
        return {
          isAgree: [{
            required: true,
            message: this.$t('请选择审批意见'),
            trigger: 'blur'
          }],
          approvalDescription: [{
            required: true,
            message: this.$t('请输入审批描述'),
            trigger: 'blur'
          }],
        };
      },
    },
    methods: {
      viewSig(){
        this.visibleSig = true;
      },
      handleSigCancel(){
        this.visibleSig = false;
      },
      downloadSig(){
        this.downloadFile(this.tearDownModel.applySignature, this.$t('签名'))
      },
      downloadFile(url, name) {
        console.log('url==', url)
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", name)
        a.setAttribute("target", "_blank")
        let clickEvent = document.createEvent("MouseEvents")
        clickEvent.initEvent("click", true, true)
        a.dispatchEvent(clickEvent)
      },
      getpriceList(){
        let that = this;
        getAction(this.url.priceList,{pageSize:1000}).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(that.priceList, item.id, item.wtName)
            })
          }
        })
      },
      getuserTypeList(){
        this.userTypeList = {};
        getAction(this.url.userTypeList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(this.userTypeList, item.id, item.utName)
            })
          }
        })
      },
      init(row,type){
        this.visible = true;
        if(type == "approve"){
          this.optionType = type
          this.title = this.$t('用水性质变更审批');
          this.notInput = false;
          this.disableSubmit = false;
        }else{
          this.optionType = type
          this.title = this.$t('用水性质变更详情');
          this.notInput = true;
          this.disableSubmit = true;
        }
        this.infoId = row.id
        // this.model = JSON.parse(JSON.stringify(row));
        this.tearDownModel = {};
        this.installModel = {};
        this.tearDownInit();
      },
      // 报停 初始化
      tearDownInit(){
        let that = this;
        // 获取报停数据
        getAction(this.url.queryById,{id:this.infoId}).then(res=>{
          if(res.success){
              that.tearDownModel = {...res.result}
              // 本人身份证
              let userIdCardFront = that.tearDownModel.userIdCardFront ? [that.tearDownModel.userIdCardFront] : [];
              let userIdCardOpposite = that.tearDownModel.userIdCardOpposite ? [that.tearDownModel.userIdCardOpposite] : [];

              // 被委托人身份证
              let reportUserIdCardFront = that.tearDownModel.reportUserIdCardFront ? [that.tearDownModel.reportUserIdCardFront] : [];
              let reportUserIdCardOpposite = that.tearDownModel.reportUserIdCardOpposite ? [that.tearDownModel.reportUserIdCardOpposite] : [];

              this.$nextTick(()=>{
                  this.$set(that,'fileList',[...userIdCardFront, ...userIdCardOpposite].join(','));
                  this.$set(that,'reportUserFileList',[...reportUserIdCardFront, ...reportUserIdCardOpposite].join(','));
              })
              that.tearDownModel.valueJson = JSON.parse(that.tearDownModel.valueJson?that.tearDownModel.valueJson:'{}');
              if(that.tearDownModel.applyType == 4 || that.tearDownModel.applyType == 5) that.getpriceList();
              if(that.tearDownModel.applyType == 5) that.getuserTypeList();
              
          }
          
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        if(this.optionType == "详情" ){
          this.close()
          return
        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let resultMessage = ''
            if(this.tearDownModel.isAgree){
              resultMessage = this.$t('审批通过')
            }else{
              resultMessage = this.$t('审批已驳回，工单存放在已办。')
            }
            let params = JSON.parse(JSON.stringify(this.tearDownModel));
            params.valueJson = JSON.stringify(this.tearDownModel.valueJson);
            postAction(this.url.updateState, params).then((res) => {
              if (res.success) {
                that.$message.success(resultMessage);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>
<style lang="less" scoped>
  .box-sig{
    width: 200px;
    height: 100px;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask-sig{
      visibility: hidden;
      position: absolute;
      width: 180px;
      height: 80px;
      top: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      cursor: pointer;
      
      .icon-sig{
        color: rgba(255, 255, 255, 0.85);
        font-size: 16px;
      }
    }
    .mask-show{
      visibility: visible;
      transition: all 0.3s;
    }
  }
</style>